export const environment = {
    production: false,
    // TESTING
    //apiUrl: 'http://localhost:3202/api',

    // Production
    apiUrl: 'https://palladio-leads.de/api',
};
